import Styled from 'styled-components';

export const StyledSpan = Styled.span`
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
export const StyledSVG = Styled.svg`
	cursor: pointer;
	fill: ${props => (props.active ? props.theme.colors.starYellow : props.theme.colors.textGray)};
	&:hover	{ 
		fill: ${props => props.theme.colors.starYellow};
	}
`;
